import React, { useContext } from 'react';
import styles from './FooterBanner.module.css';


function FooterBanner(props) {
    return (
        <React.Fragment>
            <div className={styles.footer_banner}>
                        <div className={styles.footer_banner_content}>
                            <h2>
                                <b>
                                    Got any questions?
                                </b>
                            </h2>
                            <br/>
                            <p>
                                Call our team of experts at 1-877-371-BASF (2273) to reach <b>AgSolutions<sup>®</sup></b> Customer Care.
                            </p>
                        </div>
                        <br/>
                        <a 
                            data_tealium_category="link"
							data_tealium_action="click"
							data_tealium_type="click social-link"
							data_tealium_value= "Twitter|https://twitter.com/basfagsolutions"
                            href="https://twitter.com/basfagsolutions" target="_blank" rel="noopener noreferrer" className={`${styles.social_link} ${styles.social_twitter}`} title="Join us in Twitter"
                        >
                            <i title="Join us in Twitter"></i>
                        </a>
                        <a 
                            data_tealium_category="link"
                            data_tealium_action="click"
                            data_tealium_type="click social-link"
                            data_tealium_value= "Youtube|https://www.youtube.com/user/BASFAgSolutions"
                            href="https://www.youtube.com/user/BASFAgSolutions" target="_blank" rel="noopener noreferrer" className={`${styles.social_link} ${styles.social_youtube}`} title="Join us in YouTube"
                        >
                            <i title="Join us in YouTube"></i><span className={styles.social_name}>YouTube</span>
                        </a>
            </div>
        </React.Fragment>
    );
}

export default FooterBanner;